import React from 'react';
import { ProjectGq } from '../../../graphql/projects/models/ProjectGq';
import { CurrentUserGq } from '../../../graphql/users/models/CurrentUserGq';
import { useCopyProjectForm } from '../Forms/CopyProjectForm/useCopyProjectForm';
import VoxelDialog from '../../voxel/Dialogs/VoxelDialog';
import VoxelDialogActions from '../../voxel/Dialogs/VoxelDialogActions';
import VoxelDialogContent from '../../voxel/Dialogs/VoxelDialogContent';
import VoxelInput from '../../voxel/Forms/VoxelInput';
import VoxelDialogActionCancel from '../../voxel/Dialogs/VoxelDialogActionCancel';
import VoxelDialogActionSubmit from '../../voxel/Dialogs/VoxelDialogActionSubmit';

export interface CopyProjectDialogProps {
  close: () => void;
  project: ProjectGq;
  onSuccess: (id: ProjectGq) => Promise<void>;
  user: CurrentUserGq;
}

const CopyProjectDialog: React.FC<CopyProjectDialogProps> = ({
  close,
  project,
  onSuccess,
  user,
}) => {
  const formikProps = useCopyProjectForm(project, onSuccess, user);

  return (
    <form onSubmit={formikProps.handleSubmit}>
      <VoxelDialog title="Copy project" open={true} onClose={close}>
        <VoxelDialogContent>
          <VoxelInput
            label={'New project name'}
            labelPosition="top"
            value={formikProps.values.newName}
            placeholder={'Example project'}
            disabled={formikProps.isSubmitting}
            onChange={(event) => formikProps.setFieldValue('newName', event.target.value)}
            autoFocus={true}
            helperText={formikProps.errors?.newName}
          />
        </VoxelDialogContent>
        <VoxelDialogActions>
          <VoxelDialogActionCancel onClick={close} disabled={formikProps.isSubmitting} />
          <VoxelDialogActionSubmit
            title={'Copy project'}
            onClick={formikProps.submitForm}
            disabled={!formikProps.isValid || formikProps.isSubmitting}
          />
        </VoxelDialogActions>
      </VoxelDialog>
    </form>
  );
};

export default CopyProjectDialog;
